<template>
   <div :class="`text-${props.align}`" class="my-4">
      <p class="text-sm font-medium mb-1">
         Talktime is
         <span class="text-primary-500">HIPPA Verified and ISO 27001 Certified</span>. We are
         committed to provide you with the highest standards of security and privacy.
      </p>
      <div v-if="isStamp" class="flex items-center justify-between">
         <div :class="props.align === 'center' ? 'mx-auto justify-center' : ''" class="my-4 flex">
            <div class="mr-2">
               <img src="@/assets/image/hippa.png" />
            </div>
            <div>
               <img src="@/assets/image/iso.png" />
            </div>
         </div>
         <img width="130" src="@/assets/image/talktime-stamp1.svg" />
      </div>
   </div>
</template>
<script setup>
   const props = defineProps({
      align: {
         type: String,
         default: 'center',
      },
      isStamp: {
         type: Boolean,
         default: false,
      },
   });
</script>
